import { type PropsWithChildren } from 'react'

import { cn } from '@hap/components'

const spacingVariants = {
  sm: 'space-y-4', // 16px - for list pages with tables/cards
  base: 'space-y-12', // 48px - for detail/form pages
} as const

interface SettingsContentProps extends PropsWithChildren {
  /** Vertical spacing between child elements. 'sm' for lists, 'base' for detail pages. */
  spacing?: keyof typeof spacingVariants
  className?: string
}

/**
 * Standard content wrapper for settings pages.
 * Provides consistent horizontal gutters, vertical padding (32px top, 48px bottom),
 * and configurable spacing between child elements.
 */
export function SettingsContent({
  children,
  spacing = 'base',
  className,
}: SettingsContentProps) {
  return (
    <div className={cn('gutters pb-12 pt-8', spacingVariants[spacing], className)}>
      {children}
    </div>
  )
}
